import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=b4128b0c&scoped=true&"
import script from "./Wait.vue?vue&type=script&lang=js&"
export * from "./Wait.vue?vue&type=script&lang=js&"
import style0 from "./Wait.vue?vue&type=style&index=0&id=b4128b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4128b0c",
  null
  
)

export default component.exports